import './styles/themes/natural.css';
import './styles/natural-gallery.full.scss';

export { Gallery } from './js/Gallery';



// WEBPACK FOOTER //
// ./app/full.ts